import { render, staticRenderFns } from "./ItemPage.vue?vue&type=template&id=30073e50&scoped=true&lang=pug&"
import script from "./ItemPage.vue?vue&type=script&lang=ts&"
export * from "./ItemPage.vue?vue&type=script&lang=ts&"
import style0 from "./ItemPage.vue?vue&type=style&index=0&id=30073e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30073e50",
  null
  
)

export default component.exports